module.exports = __webpack_public_path__ + "img/train.19f28eca.svg";